module.exports = __webpack_public_path__ + "static/img/1.e81890e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/1.jpg
// module id = ozBn
// module chunks = 1